import { useEffect } from 'react';

import type { DocNode } from '@atlaskit/adf-schema/doc';
import { useRendererContext } from '@atlaskit/renderer/renderer-context';

import { useRendererActionsDispatch } from '@confluence/renderer-actions/entry-points/RendererActionsContext.ts';

/** Publishes the page document without letting nested renderers overwrite it. */
export const PageAdfPublisher = ({
	document,
	isTopLevelRenderer,
}: {
	document: DocNode | undefined;
	isTopLevelRenderer?: boolean;
}): null => {
	const { isTopLevelRenderer: ancestorRenderer } = useRendererContext();
	const { setPageAdf } = useRendererActionsDispatch();

	useEffect(() => {
		// Platform leaves this field undefined outside a renderer. Both true (under the root)
		// and false (under a nested renderer) mean this document belongs to a subtree.
		if (ancestorRenderer === undefined && isTopLevelRenderer !== false) {
			setPageAdf(document);
		}
	}, [ancestorRenderer, document, isTopLevelRenderer, setPageAdf]);

	return null;
};
